import React from "react";
import Modal from "./Modal.tsx";

export const CareNoteModal = ({
  showCareNoteModal,
  setShowCareNoteModal,
  submitCareNote,
  setCareNote,
  careNote,
  isLoading,
}) => {
  return (
    <Modal
      title="Add Care Note"
      size="md"
      onCancel={() => setShowCareNoteModal(false)}
      isOpen={showCareNoteModal}
    >
      <form>
        <div className="form__group">
          <label htmlFor="careNote" className="mb-2">
            Care Note:
          </label>
          <div className="form__input">
            <textarea
              value={careNote}
              onChange={(e) => setCareNote(e.target.value)}
              required
            />
          </div>
        </div>
        <button
          type="button"
          onClick={() => submitCareNote(careNote)}
          className="btn btn__primary btn--block"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </form>
    </Modal>
  );
};
